import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";

export interface Testimonial {
  id: string;
  header: string | null;
  content: string;
  quality_score: number | null;
  service_type: string | null;
  service_name_ko: string | null;
  service_name_en: string | null;
  experience: string | null;
  title: string | null;
  isLegacy: boolean;
}

export function useTestimonials() {
  const [testimonials, setTestimonials] = useState<Testimonial[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    async function fetchData() {
      const { data, error } = await supabase
        .from("reviews")
        .select(`
          id,
          content,
          headline,
          best_part,
          quality_score,
          service_type,
          experience,
          status,
          customers ( target_position ),
          service_types!service_type ( name_ko, name_en )
        `)
        .eq("marketing_usable", true)
        // legacy(content 있음) OR 신규 승인(status = approved)
        .or("content.not.is.null,status.eq.approved")
        .order("registered_at", { ascending: false });

      if (cancelled) return;

      if (error) {
        console.error("[useTestimonials] query error:", error);
        setError(error.message);
      } else {
        const mapped: Testimonial[] = (data ?? []).map((row: any) => {
          const isLegacy = row.content !== null;
          return {
            id: row.id,
            header: row.headline ?? null,
            content: row.content ?? row.best_part ?? "",
            quality_score: row.quality_score,
            service_type: row.service_type ?? null,
            service_name_ko: row.service_types?.name_ko ?? null,
            service_name_en: row.service_types?.name_en ?? null,
            experience: row.experience ?? null,
            title: row.customers?.target_position ?? null,
            isLegacy,
          };
        });
        setTestimonials(mapped);
      }
      setLoading(false);
    }

    fetchData();
    return () => { cancelled = true; };
  }, []);

  const avgScore =
    testimonials.length > 0
      ? testimonials.reduce((sum, t) => sum + (t.quality_score ?? 0), 0) /
        testimonials.length
      : 0;

  return { testimonials, loading, error, avgScore };
}
